<template>
	<vxe-modal :loading="loading" v-model="modal" width="500" height="auto" @show="show" title="编辑" destroy-on-close
		:showFooter="true" @hide="hide">
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="序列号ID">
					<el-input disabled v-model="form.serialId"></el-input>
				</el-form-item>
				<el-form-item label="关联单据">
					<el-input v-model="form.serialNo"></el-input>
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="primary" content="提交" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				options:[],
				form: {
					serialId: null,
					serialNo: null,
				},
			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				this.form.serialId = this.row.serialId
				this.form.serialNo = this.row.serialNo
				console.log(this.form)

			},
			cancel() {
				this.form.serialId = null
				this.form.serialNo = null
				this.modal = false
			},
			hide() {
				this.form.serialId = null
				this.form.serialNo = null
				this.$emit('hide')
			},
			show() {
				this.activeName = 'track'
				this.init()
			},

			modalShow() {
				this.modal = true
			},

			submit() {
				//console.log(this.form)
				this.$api.purchaserelationflow.relation( {
					serialId: this.form.serialId,
					serialNo: this.form.serialNo
				}).then(() => {
					this.$message.success('操作成功')
					this.$emit('success')
					this.cancel()
				})

				//this.cancel()
			}
		},
		components: {

		}
	}
</script>